const videos = document.querySelectorAll('[data-video-id]');
if (videos) {
    for (const video of videos) {
        const {id, thumbnail, showUrl} = video.dataset;
        if (id) {
            const endpoint = 'https://www.googleapis.com/youtube/v3/videos';
            axios.get(endpoint, {
                params: {
                    key: googleKey,
                    part: 'snippet',
                    id
                }
            })
                .then((r) => {
                    const code = [];
                    if (r.data.items.length > 0) {
                        const tb = r.data.items[0].snippet.thumbnails.high;
                        code.push(`<a href="${showUrl}"><img src="${tb.url}" width="${tb.width}" height="${tb.height}" class="img-fluid"></a>`);
                    } else {
                        code.push(`<a href="${showUrl}"><img src="${thumbnail}" class="img-fluid"></a>`);
                    }
                    video.innerHTML = code.join('');
                })
                .catch((err) => {
                    console.log(err.response ? err.response : (err.request ? err.request : err));
                    const code = `<a href="${showUrl}"><img src="/images/no-thumbnail-default.png" width="640" height="480" class="img-fluid"></a>`;
                    video.innerHTML = code;
                });
        }
    }
}

// public 글쓰기 모드
const publicEditor = document.getElementById('editor-content');
if (publicEditor) {
    tinyMCE.init({
        selector: 'textarea#editor-content',
        menubar: false,
        language: 'ko_KR',
        plugins: 'print preview fullpage paste importcss searchreplace autolink autosave autoresize save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap emoticons',
        toolbar_sticky: true,
        toolbar: 'bold italic | alignleft aligncenter alignright alignjustify | numlist bullist | forecolor backcolor removeformat | charmap emoticons link',
        autoresize_bottom_margin: 50,
        branding: false,
        min_height: 500,
        directionality: 'ltr'
    });
}

// 글 저장
const publicForm = document.getElementById('publicForm');
if (publicForm) {
    publicForm.addEventListener('submit', async (e) => {
        e.preventDefault();

        const f = e.target;
        const editorContent = tinyMCE.activeEditor.selection.getNode().innerHTML;

        if (!f.title.value || f.title.value.length === 0) {
            alert('제목을 입력하세요.');
            f.title.focus();
            return false;
        }
        if (editorContent.innerHTML === '<p><br data-mce-bogus="1"></p>' || editorContent.innerHTML === '<br data-mce-bogus="1">') {
            alert('내용을 입력하세요.');
            tinymce.activeEditor.focus();
            return false;
        }

        try {
            const fd = new FormData(e.target);
            fd.append('content', tinymce.activeEditor.selection.getNode().innerHTML);

            const progress = e.target.querySelector('.progress');
            const bar = progress.querySelector('.progress-bar');

            progress.style.display = '';
            const r = await axios.post(f.action, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                onUploadProgress: (progressEvent) => {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    bar.style.width = `${percentCompleted}%`;
                    bar.setAttribute('aria-valuenow', percentCompleted);
                }
            });

            console.log(r.data.redirectTo);
            return false;
            location.href = r.data.redirectTo;

        } catch (err) {
            console.log(err.response ? err.response : (err.request ? err.request : err));
            alert('글 저장 중 오류가 발생했습니다.\n관리자에게 문의바랍니다.');
        }
    });
}
